import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { Spinner } from 'react-awesome-spinners';
import { apiV2 } from './../../services/api';
import Section from './components/Section';
import { Container, ContainerEmpty, Row, Main, Grid } from './styles';

function NewListVacancies({
  params,
  company,
  search,
  departmentSelected,
  locationSelected,
  regimeSelected,
  modelSelected,
  perPage,
  query,
}) {
  const [vacancies, setVacancies] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function load() {
      setVacancies([]);
      setLoading(true);
      try {
        const { label, page_label } = query;

        const vacanciesUrl =
          !isEmpty(label) && !isEmpty(page_label)
            ? `vacancies/per-departments/${label}/${page_label}`
            : `vacancies/per-departments/${label}`;

        const { data } = await apiV2.post(vacanciesUrl, {
          search,
          department: departmentSelected?.value,
          location: locationSelected?.value,
          regime: regimeSelected?.value,
          model: modelSelected?.value,
        });
        
        // Verificação de segurança para evitar erros quando data.data é undefined
        if (data && data.data && data.data.vacancies) {
          setVacancies(data.data.vacancies);
        } else {
          console.warn('API response data structure is invalid:', data);
          setVacancies([]);
        }
      } catch (error) {
        console.error('Error loading vacancies:', error);
        setVacancies([]);
        setLoading(false);
      }

      setLoading(false);
    }

    let isMounted = true;

    if (isMounted && query) {
      load();
    }

    return () => {
      isMounted = false;
    };
  }, [
    query,
    params,
    page,
    search,
    departmentSelected,
    locationSelected,
    regimeSelected,
    modelSelected,
  ]);

  return (
    <Main id="vacancies">
      <Container primaryColor={company?.base_hexcolor}>
        {vacancies.length > 0 ? (
          <>
            <Grid>
              {vacancies?.map((vacancy, i) => (
                <Section
                  key={`vacancy${i}`}
                  query={query}
                  vacancy={vacancy}
                  params={params}
                  company={company}
                />
              ))}
            </Grid>
          </>
        ) : loading ? (
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              padding: '20px',
              flexDirection: 'column',
              background: '#FFF',
              borderRadius: '6px',
              height: '100px',
            }}
          >
            <Spinner size="large" />
          </div>
        ) : (
          <ContainerEmpty>
            <h2>Ops!</h2>
            <h4>Ainda não existe nenhuma vaga cadastrada aqui.</h4>
            <p>
              Enquanto isso, você pode enviar seu currículo para nosso banco de
              talentos, assim nossos recrutadores poderão encontrar a vaga que
              melhor se encaixa no seu perfil.
            </p>
            <a href={`${process.env.REACT_APP_TALENT_URL}/${params}/signup`}>
              Quero entrar no Banco de Talentos
            </a>
            <img
              src="/static/undraw_empty_vacancies.svg"
              alt="Empty vacancies illustration"
            />
          </ContainerEmpty>
        )}
      </Container>
    </Main>
  );
}

export default NewListVacancies;
